'use strict';

module.exports = '3.30.0';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch/src/version.js
// module id = 48
// module chunks = 0